function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import find from 'lodash/find';
import get from 'lodash/get';
import map from 'lodash/map';
import includes from 'lodash/includes';
import valuesIn from 'lodash/valuesIn';
import filter from 'lodash/filter';
import { AppContext } from 'context';
import Button from 'components/Form/Button';
import SwitchIcon from 'svg/ap/switch.svg';
import App, { AlertsBus } from 'modules/App';
import * as actions from '../../actions';
import * as constants from '../../constants';
import * as selectors from '../../selectors';
import * as shapes from '../../shapes';
import messages from '../../messages';
import ContourCloudInfo from '../../partials/ContourCloudInfo';
import AppBox from './AppBox';
import styles from './AppCatalog.pcss';
var _React_PureComponent;
class AppCatalog extends (_React_PureComponent = React.PureComponent) {
    get availableApps() {
        const { countryCode, scope } = this.props.loadedIdentity;
        return filter(valuesIn(constants.APPS), (app)=>includes(app.scopes, scope) && !get(app, 'isHiddenInAppCatalog', false) && (app.countries.length === 0 || includes(app.countries, countryCode)));
    }
    get country() {
        const { countryCode: alpha2Code } = this.props.loadedIdentity;
        const country = find(this.props.countries, {
            alpha2Code
        });
        return country ? get(this.props.localizationResources, [
            country.nameKey,
            'value'
        ], country.englishName) : alpha2Code;
    }
    get scope() {
        const { scope } = this.props.loadedIdentity;
        return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.scopes[scope]));
    }
    renderSwitchIdentityBtn() {
        if (this.props.identities.length < 2) {
            return null;
        }
        return /*#__PURE__*/ _jsxs(Button, {
            type: "link",
            to: this.switchIdentityUrl,
            styleModifier: "transparent-primary",
            className: "btn--md ml-10",
            children: [
                /*#__PURE__*/ _jsx(SwitchIcon, {
                    className: "btn__icon mr-3"
                }),
                /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.buttons.switchIdentity))
            ]
        });
    }
    renderHeader() {
        return /*#__PURE__*/ _jsxs("header", {
            className: "pageHeader d-lg-flex align-items-center justify-content-between",
            children: [
                /*#__PURE__*/ _jsx("h1", {
                    className: "text--h1",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.appCatalog))
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "d-flex d-lg-block align-items-center justify-content-between",
                    children: [
                        /*#__PURE__*/ _jsxs("span", {
                            children: [
                                /*#__PURE__*/ _jsxs("span", {
                                    className: "ml-4 pt-3 pt-md-0 d-block d-md-inline",
                                    children: [
                                        /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, App.messages.labels.country)),
                                        ": ",
                                        /*#__PURE__*/ _jsx("b", {
                                            children: this.country
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("span", {
                                    className: "ml-4 pt-3 pt-md-0 d-block d-md-inline",
                                    children: [
                                        /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.profile)),
                                        ": ",
                                        /*#__PURE__*/ _jsx("b", {
                                            children: this.scope
                                        })
                                    ]
                                })
                            ]
                        }),
                        this.renderSwitchIdentityBtn()
                    ]
                })
            ]
        });
    }
    renderContourCloudInfo() {
        const { identityProviderType } = this.props.loadedIdentity;
        if (identityProviderType !== 'ContourCloud') {
            return null;
        }
        return /*#__PURE__*/ _jsx("div", {
            className: `pageContentBox ${styles.root} mt-7`,
            children: /*#__PURE__*/ _jsx(ContourCloudInfo, {
                identity: this.props.loadedIdentity
            })
        });
    }
    render() {
        // if (this.availableApps.length === 1) {
        //   return null;
        // }
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: `pageContentBox ${styles.root}`,
                    children: [
                        this.renderHeader(),
                        /*#__PURE__*/ _jsx(AlertsBus, {
                            className: "mb-5"
                        }),
                        map(this.availableApps, (app)=>/*#__PURE__*/ _jsx(AppBox, {
                                app: app
                            }, app.key)),
                        /*#__PURE__*/ _jsx(AppBox, {
                            app: constants.ACCOUNT_PORTAL,
                            to: this.accountPortalUrl
                        }, constants.ACCOUNT_PORTAL.key)
                    ]
                }),
                this.renderContourCloudInfo()
            ]
        });
    }
    constructor(props, context){
        super(props);
        this.accountPortalUrl = context.getUrl('personal-information');
        this.switchIdentityUrl = context.getUrl('switch-identity');
    // if (this.availableApps.length === 1) {
    //   this.props.onGoToApp(this.availableApps[0].key);
    // }
    }
}
_define_property(AppCatalog, "contextType", AppContext);
_define_property(AppCatalog, "propTypes", {
    // Implicit props
    loadedIdentity: shapes.identity,
    identities: PropTypes.arrayOf(shapes.identity),
    countries: PropTypes.arrayOf(App.shapes.country),
    localizationResources: PropTypes.object,
    // Implicit actions
    onGoToApp: PropTypes.func
});
const mapStateToProps = (state)=>({
        identities: selectors.identities(state),
        loadedIdentity: selectors.loadedIdentity(state),
        countries: App.selectors.countries(state),
        localizationResources: App.selectors.localizationResources(state)
    });
const mapDispatchToProps = (dispatch)=>({
        onGoToApp: (app)=>dispatch(actions.goToApp(app))
    });
const ConnectedAppCatalog = connect(mapStateToProps, mapDispatchToProps)(AppCatalog);
export default withStyles(styles)(ConnectedAppCatalog);
